import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useClientContext, useIsSmartPageM365BannerEnabled, useIsM365Premium } from '@bingads-webui-campaign-react/smart-page-context';

import { SmartBannerView } from './smart-banner-view';

export const SmartBannerConnector = ({ customedContent }) => {
  const i18n = useContext(I18nContext);
  const { isMobile } = useClientContext();
  const isSmartPageM365BannerEnabled = useIsSmartPageM365BannerEnabled();
  const isM365Premium = useIsM365Premium();

  if (isSmartPageM365BannerEnabled && !isM365Premium) {
    return (
      <SmartBannerView
        i18n={i18n}
        isMobile={isMobile}
        customedContent={customedContent}
      />
    );
  }

  return null;
};

SmartBannerConnector.propTypes = {
  customedContent: PropTypes.element,
};

SmartBannerConnector.defaultProps = {
  customedContent: null,
};
